import React, { createElement, useMemo } from 'react';

const EntityElement = ({ children, ...props }) => {
  return createElement('entity', props, children);
};

const Emoji = ({ emoji, jumbo = false, superJumbo = false }) => {
  let size = 'size-4';
  if (superJumbo) size = 'size-40';
  else if (jumbo) size = 'size-13';

  return (
    <img
      src={emoji.public_url}
      alt={emoji.native ? emoji.native : `:${emoji.shortcode}:`}
      className={size}
      data-controller="tippy"
      data-tippy-theme="mini"
      data-tippy-content={`:${emoji.shortcode}:`}
    />
  );
};

export const EmojiEntity = ({ emoji, dataId = null, dataName = null, jumbo = false, superJumbo = false, suggestion = false }) => {
  const classes = useMemo(() => {
    let classes = ['inline-flex'];
    if (suggestion) classes.push('pointer-events-none');

    if (jumbo || superJumbo) {
      classes.push('items-center justify-center align-middle');
      if (superJumbo) classes.push('h-40');
      else if (jumbo) classes.push('h-13');
    } else {
      classes.push('relative top-0.5 h-4');
    }

    return classes.join(' ');
  }, [jumbo, superJumbo, suggestion]);

  return (
    <EntityElement data-type="emoji" data-id={dataId} data-name={dataName} className={classes}>
      {!emoji && <span className="cursor-default font-mono text-gray-400">{`:${dataName || 'unknown'}:`}</span>}
      {emoji && <Emoji emoji={emoji} jumbo={jumbo} superJumbo={superJumbo} suggestion={suggestion} />}
    </EntityElement>
  );
};
